/**
 * Access redux store outside component or action creator
 */

let dispatchFunc = () => {};

const setDispatch = (_dispatchFunc) => {
  dispatchFunc = _dispatchFunc;
};

export const dispatch = (params) => dispatchFunc(params);

const globalReduxStore = (() => {
  let rdxStore;
  function setStore(store) {
    if (!rdxStore) {
      rdxStore = store;
      setDispatch(store.dispatch);
    }
  }

  function getStore() {
    return rdxStore;
  }

  function getState(storeStateKeys) {
    const state = rdxStore.getState();

    if (storeStateKeys?.length) {
      const stateByKeys = {};
      storeStateKeys.forEach((key) => {
        if (state[key]) stateByKeys[key] = state[key];
      });

      return stateByKeys;
    }

    return state;
  }

  return {
    setStore,
    getStore,
    getState,
  };
})();

export default globalReduxStore;
